var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.22222 14.6922H20.7778C21.45 14.6922 22 14.1528 22 13.4935C22 12.8342 21.45 12.2948 20.7778 12.2948H1.22222C0.55 12.2948 0 12.8342 0 13.4935C0 14.1528 0.55 14.6922 1.22222 14.6922ZM1.22222 8.69864H20.7778C21.45 8.69864 22 8.15922 22 7.49992C22 6.84063 21.45 6.30121 20.7778 6.30121H1.22222C0.55 6.30121 0 6.84063 0 7.49992C0 8.15922 0.55 8.69864 1.22222 8.69864ZM0 1.50634C0 2.16563 0.55 2.70505 1.22222 2.70505H20.7778C21.45 2.70505 22 2.16563 22 1.50634C22 0.84704 21.45 0.307617 20.7778 0.307617H1.22222C0.55 0.307617 0 0.84704 0 1.50634Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ba8bda0f123b6603335ff5fa3661cd4a.svg";
export { ForwardRef as ReactComponent };